import { useEffect, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import SideBar from '../OrderPage/SideBar.js';
import Header from '../Header/Header.js';
import SettingsHeader from '../OrderPage/SettingsHeader.js';
import { GiSettingsKnobs } from 'react-icons/gi';
import { useMutation, useQuery } from '@apollo/client';
import { GET_BANK_DETAILS_BY_ID } from '../graphql/Query/SellerPruff.js';
import { CREATE_BANK_DETAILS } from '../graphql/Mutation/Signin.js';
import { toast } from 'react-toastify';
import SpinLoader from '../components/SpinLoader.js';

const SellerGST = () => {
    const [createBankDetails, { loading }] = useMutation(CREATE_BANK_DETAILS)
    const { data, refetch } = useQuery(GET_BANK_DETAILS_BY_ID, {
        fetchPolicy: "cache-and-network"
    })
    const [initialValues, setInitialValues] = useState({
        gstNumber: '',
    });

    useEffect(() => {
        if (data?.getBankDetailsById) {
            setInitialValues({
                gstNumber: data?.getBankDetailsById?.gstNumber || '',
            });
        }
    }, [data]);
    const validationSchema = Yup.object().shape({
        gstNumber: Yup.string()
            .required("GST Number is required")
            .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Enter a valid GST Number"),
    });

    const onSubmit = async (values, { resetForm }) => {
        try {
            const data = await createBankDetails({
                variables: {
                    input: {
                        gstNumber: values?.gstNumber,
                    },
                },
            });
            if (data?.data?.createBankDetails?.status) {
                toast.success(data?.data?.createBankDetails?.message);
                refetch()
                resetForm()
            }
        } catch (err) {
            toast.error(err.message);
        }

    };
    return (
        <>

            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar
                />

                {/* Main Content */}
                <div className="flex-1 space-y-6 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <SettingsHeader />
                    <div className="grid grid-cols-12 md:space-x-7 min-h-screen">
                        {/* Sidebar (Left Panel) */}
                        <div className="col-span-3 bg-white p-6 rounded-md hidden md:block">
                            {/* Content for sidebar */}
                            <h1 className='font-semibold text-xl mb-6'>Settings</h1>
                            <p>Take your shipping experience a notch higher with us by regulating your panel settings as per your convenience and specific business requirements. From importing orders to managing labels and all other account settings, get everything at the tap of your finger for an uninterrupted experience.</p>
                            <GiSettingsKnobs className="h-96 w-96 text-slate-100" />
                        </div>

                        {/* Main Content (Right Panel) */}
                        <div className="col-span-12 md:col-span-9 rounded-md bg-white p-4">
                            <p className="px-4 py-2 mb-7 border border-sky-100 bg-sky-50">Business GST Verification</p>
                            {/* Main content goes here */}
                            {/* <div className="max-w-4xl mx-auto mt-10 p-6 bg-white rounded-lg shadow-md"> */}
                            {/* <h2 className="text-2xl font-bold mb-6">Upload Your Documents</h2> */}

                            <Formik
                                enableReinitialize
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {({ setFieldValue }) => (
                                    <Form className="max-w-md 2xl:max-w-3xl justify-start mt-6">
                                        <label className="block text-gray-700 font-medium text-sm mb-2">
                                            GST Number <span className="text-red-500">*</span>
                                        </label>
                                        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden focus-within:border-slate-800">
                                            <Field
                                                type="text"
                                                name="gstNumber"
                                                placeholder="Enter GST Number"
                                                disabled={!!initialValues?.gstNumber}
                                                className="w-full px-4 py-2 text-sm focus:outline-none focus:ring-0 text-gray-800"
                                                onChange={(e) => setFieldValue("gstNumber", e.target.value)}
                                            />
                                            <button
                                                type="submit"
                                                disabled={!!initialValues?.gstNumber}
                                                className="bg-slate-800 hover:bg-slate-900 cursor-pointer text-white text-sm font-semibold px-6 py-2 transition-all"
                                            >
                                                Submit {loading && <SpinLoader className="text-sm ms-3" />}
                                            </button>
                                        </div>
                                        <ErrorMessage name="gstNumber" component="div" className="text-red-500 text-sm mt-2" />
                                    </Form>
                                )}
                            </Formik>
                            {/* </div> */}
                        </div>
                    </div>



                </div>

            </div >
        </>
    )
}

export default SellerGST
